export class Constants {
  static readonly xs: number = 576;
  static readonly sm: number = 768;
  static readonly md: number = 991;
  static readonly lg: number = 1200;
}
